import { iconRequest, iconSearch,iconClient,iconCalculator } from '../defaultValues';

const data = {
    role_2fc8d1cf143843759761da0ae2f3b1ae: [
        {
            id: 'solicitudesSeguros',
            icon: iconRequest,
            label: 'Solicitudes Seguros',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        }
    ],
};
export default data;
